<template>
  <nav id="Playout" class="navbar navbar-expand-lg navbar-light bg-delta fixed-top">
    <div class="drawer-toggle-web" role="button" @click="$store.dispatch('toggleMainSidebar')">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>

    <div class="brand-name navbar-brand text-white">
      <a href="/">
        <img class="logo" src="@/assets/img/logo-s.svg" />
      </a>
      <a href="/">
        <span class="project-name">{{ $t("pages.wording.deltaPlatform") }}</span
        ><!--DELTA 智能放行平台-->
      </a>
    </div>

    <div class="drawer-toggle" role="button" @click="$store.dispatch('toggleSidebar')">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>

    <div class="app-links collapse navbar-collapse justify-content-end">
      <HeaderNav />
    </div>
  </nav>
</template>

<script>
import HeaderNav from "@/components/HeaderNav.vue"
export default {
  name: "Header",
  components: {
    HeaderNav,
  },
  data() {
    return {
      fullWidth: 0,
    }
  },
  mounted() {
    const vm = this
    vm.fullWidth = window.innerWidth
    window.onresize = () => {
      vm.fullWidth = window.innerWidth
      /* 當視窗變大，Menu要關閉 */
      if (vm.fullWidth > 767) {
        this.$store.state.toggleSidebar = false
      }
    }
  },
}
</script>

<style scoped>
header {
  color: #fff;
  display: grid;
  grid-template: 50px / auto 1fr;
  align-items: center;
  background: linear-gradient(145deg, #00a0e9 11%, #0f477e 75%);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  display: -ms-grid;
  -ms-grid-rows: 50px auto auto 1fr;
}
.fixed-top {
  box-shadow: 0 5px 8px -4px #909399e0;
}
.app-links {
  -ms-flex-item-align: end;
  -ms-grid-row-align: end;
  display: flex;
  justify-content: flex-end;
  justify-self: end;
  align-self: end;
  line-height: 50px;
}
.brand-name {
  margin: 0 10px;
  font-size: 1.3rem;
  padding: 0px;
}
.brand-name a {
  text-decoration: none;
  color: white;
}
.drawer-toggle .bar,
.drawer-toggle-web .bar {
  width: 90%;
  height: 2px;
  background-color: white;
}
.drawer-toggle {
  display: flex;
  justify-self: end;
  flex-direction: column;
  justify-content: space-around;
  height: 30%;
  width: 35px;
  padding-right: 16px;
  cursor: pointer;
}
.drawer-toggle-web {
  display: flex;
  justify-self: end;
  flex-direction: column;
  justify-content: space-around;
  height: 30%;
  width: 35px;
  padding-right: 16px;
  cursor: pointer;
}
.logo {
  margin-left: 15px;
  margin-right: 15px;
  height: 30px;
}
.project-name {
  margin-left: 10px;
  font-size: 20px;
  color: #ffffff;
  line-height: 50px;
}
.navbar {
  padding: 0rem 0rem 0rem 20px;
  height: 50px;
}
@media (max-width: 1025px) {
  header {
    padding: 0 16px;
  }
  header:nth-child {
    justify-self: end !important;
  }
  .fixed-top {
    left: 0px;
  }
  .app-links {
    display: none;
  }
  .navbar-light {
    height: 50px;
  }
  .drawer-toggle-web {
    display: none;
  }
  .footer {
    left: 0px;
  }
}
@media (min-width: 1026px) {
  /*.fixed-top{
		left: 0px;
	}*/
  .menuOpen .fixed-top {
    left: 299px;
  }
  .menuOpen .footer {
    left: 299px;
  }
  .app-links {
    display: flex;
  }
  .navbar-collapse {
    flex-basis: auto;
  }
  .drawer-toggle {
    display: none;
  }
  /*table incloud buttn*/
  .boxContain.includBtn {
    margin-top: 50px;
  }
  .boxContain.includBtn button {
    position: absolute;
    top: -100px;
  }
}
</style>
